<template>
  <div class="HasBeenSold-box">
    <div class="search-box" v-if="!orderInformationVisible">
      <div class="search-box-fliter-box">
        <div class="search-box-fliter">
          <el-popover
            placement="bottom-start"
            width="200"
            trigger="click"
            v-model="orderPopoverShow"
            popper-class="mobile-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': orderStatusLabelList.length > 0 }"
              slot="reference"
            >
              Order Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': orderPopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="orderStatusLabelList">
              <el-checkbox
                v-for="(item, index) in orderStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(1)"
                >Clear All</el-button
              >
              <el-button size="small" class="apply-bt" @click="applyFilter(1)"
                >Apply</el-button
              >
            </div>
          </el-popover>
          <el-popover
            placement="bottom-start"
            width="200"
            trigger="click"
            v-model="refundPopoverShow"
            popper-class="mobile-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': refundStatusLabelList.length > 0 }"
              slot="reference"
            >
              Refund Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': refundPopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="refundStatusLabelList">
              <el-checkbox
                v-for="(item, index) in refundStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(2)"
                >Clear All</el-button
              >
              <el-button size="small" class="apply-bt" @click="applyFilter(2)"
                >Apply</el-button
              >
            </div>
          </el-popover>
        </div>
        <div class="search-box-reset-box">
          <el-button class="reset-bt" size="small" @click="resetFilter(1)"
            >Reset</el-button
          >
        </div>
      </div>

      <div class="search-box-li" v-if="showFilterLabels">
        <div
          class="filters-wrapper"
          v-for="(item, index) in orderStatusLabelList"
          :key="index"
        >
          {{ item }}
        </div>
        <div
          class="filters-wrapper"
          v-for="(item, index) in refundStatusLabelList"
          :key="'refund' + index"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="myinfo-com-has-content" v-if="!orderInformationVisible">
      <div
        class="list-content"
        v-for="(item, index) in orderlist"
        :key="index"
        @click="checkOrder(item)"
      >
        <div class="list-content_item_title">
          <div class="title_main limit-length">
            {{ item.covey_course.courseName }}
          </div>

          <div class="list-content_item_status">
            <i
              :class="orderStatusMap[item.order_status].icon"
              :style="{ color: orderStatusMap[item.order_status].color }"
              >{{ orderStatusMap[item.order_status].name }}</i
            >
          </div>
        </div>

        <div class="list-content_item_container">
          <el-image
            class="info-img"
            fit="fill"
            :src="item.covey_course.courseImg[0]"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>

          <div class="list-content_item_right">
            <div class="list-content_item_between">
              <div>ID: {{ item.id }}</div>
              <div>Fee: C$ {{ item.pay_money | formatMoneyNumber }}</div>
            </div>

            <div class="list-content_item_between">
              <div :title="item.covey_user ? item.covey_user.realname : ''">
                {{ item.covey_user ? item.covey_user.realname : "" }}
                <i
                  class="chat-icon el-icon-chat-dot-square"
                  @click.stop="contactPeople(item.userId)"
                ></i>
              </div>
            </div>
            <div class="time">
              {{
                "Total:" +
                item.amounts +
                " Used:" +
                item.used_amounts +
                " Canceled:" +
                item.cancel_amounts
              }}
            </div>
          </div>
        </div>

        <div class="refund" v-if="item.refund_status !== 0">
          {{ refund_status[item.refund_status].name }}: C$
          {{ item.return_money | formatMoneyNumber }}
        </div>
        <div class="list-content_item_between margin-top_8">
          <div class="time">
            {{ format(item.create_time, "MM/DD/YYYY HH:mm:ss") }}
          </div>

          <div class="list-content_item_op">
            <div>
              <el-popover
                placement="left"
                v-if="item.refund_status && item.refund_status === 1"
                v-model="withdrawPopoverVisible"
              >
                <div style="padding: 12px; font-size: 14px">
                  <div style="font-size: 20px; line-height: 28px">
                    Refund request
                  </div>
                  <div>
                    <div style="margin-top: 12px; font-size: 14px">
                      Time submitted:<span>{{
                        format(item.refund_app_time, "MM/DD/YYYY HH:mm:ss")
                      }}</span>
                    </div>
                    <div style="margin-top: 12px; font-size: 14px">
                      Student return money:<span>{{
                        item.return_money | formatMoneyNumber
                      }}</span>
                    </div>
                    <div style="margin-top: 12px; font-size: 14px">
                      Tutor compensation amount:<span>{{
                        item.tutoraddfee | formatMoneyNumber
                      }}</span>
                    </div>
                    <div style="margin-top: 12px; font-size: 14px">
                      Your feedbacks:
                      <el-radio
                        v-model="confirmWithdrawForm.refund_status"
                        :label="2"
                        >Yes</el-radio
                      >
                      <el-radio
                        v-model="confirmWithdrawForm.refund_status"
                        :label="3"
                        >No</el-radio
                      >
                    </div>
                  </div>
                  <div style="margin-top: 20px; text-align: right">
                    <el-button
                      size="small"
                      style="background: #f48c06; color: #fff; border: none"
                      @click="handleConfirmWithdraw"
                    >
                      Sure
                    </el-button>
                  </div>
                </div>
                <div slot="reference" style="display: inline-block">
                  <el-badge is-dot>
                    <span
                      class="op"
                      size="small"
                      @click.stop="confirmWithdraw(item)"
                      >Confirm Withdraw</span
                    >
                  </el-badge>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <KtPag
      v-if="!orderInformationVisible"
      style="text-align: right"
      :pageCount="orderlistForm.count"
      :currentPage="orderlistForm.page"
      :limit="orderlistForm.limit"
      @onChange="onOrderPageChange"
    ></KtPag>

    <div class="order-information" v-if="orderInformationVisible">
      <div class="order-information_top">
        <div class="top-box flex-box">
          <el-image
            class="info-img"
            fit="fill"
            :preview-src-list="orderDetail.covey_course.courseImg"
            :src="orderDetail.covey_course.courseImg[0]"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="top-box_right">
            <div class="info-title">
              {{ orderDetail.covey_course.courseName }}
            </div>
            <div class="price">
              C$ {{ orderDetail.price | formatMoneyNumber }}
            </div>
          </div>
        </div>
      </div>

      <div class="order-information_top">
        <div class="top-box">
          <div class="list-content_item_between">
            <div>
              Student:
              {{
                orderDetail.covey_user ? orderDetail.covey_user.realname : ""
              }}
            </div>
            <div class="order-fee">
              C${{ orderDetail.pay_money | formatMoneyNumber }}
            </div>
          </div>
          <div class="list-content_item_between">
            <div>Order ID: {{ orderDetail.id }}</div>
            <span class="time">x {{ orderDetail.amounts }}</span>
          </div>

          <div class="time">
            <div>
              <span>Create Time:</span
              >{{ format(orderDetail.create_time, "MMM. Do, YYYY hh:mm A") }}
            </div>
          </div>
          <div class="time">
            <div>
              <span>Pay Time:</span
              >{{ format(orderDetail.pay_time, "MMM. Do, YYYY hh:mm A") }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-title">
        <span>
          Course List
          <i
            style="font-size: 14px"
            class="el-icon-refresh"
            @click="getChildOrderList(1)"
          ></i>
        </span>
        <a href="/#/teach/sold">
          <el-button type="text" class="goback" icon="el-icon-back"
            >Back</el-button
          >
        </a>
      </div>
      <div class="search-box">
        <div class="search-box-fliter-box">
          <div class="search-box-fliter">
            <el-popover
              placement="bottom-start"
              width="220"
              trigger="click"
              v-model="childOrderPopoverShow"
              popper-class="mobile-filter-popover"
            >
              <div
                class="filter-btn-box"
                :class="{
                  'select-filter': childOrderStatuslabelList.length > 0,
                }"
                slot="reference"
              >
                Order Status<span class="arrow-box"
                  ><i
                    class="el-icon-arrow-down"
                    :class="[{ 'submenu-icon-arrow': childOrderPopoverShow }]"
                  ></i
                ></span>
              </div>
              <el-checkbox-group v-model="childOrderStatuslabelList">
                <el-checkbox
                  v-for="(item, index) in childOrderStatusList"
                  :label="item.name"
                  :key="index"
                ></el-checkbox>
              </el-checkbox-group>
              <div class="popover-footer">
                <el-button
                  type="text"
                  size="small"
                  class="clear-bt"
                  @click="clearFilterLabel(3)"
                  >Clear All</el-button
                >
                <el-button
                  size="small"
                  class="apply-bt"
                  @click.stop="applyFilter(3)"
                  >Apply</el-button
                >
              </div>
            </el-popover>
            <el-popover
              placement="bottom-start"
              width="220"
              trigger="click"
              v-model="commentStatusPopoverShow"
              popper-class="mobile-filter-popover"
            >
              <div
                class="filter-btn-box"
                :class="{ 'select-filter': commentStatusLabelList.length > 0 }"
                slot="reference"
              >
                Comment Status<span class="arrow-box"
                  ><i
                    class="el-icon-arrow-down"
                    :class="[
                      { 'submenu-icon-arrow': commentStatusPopoverShow },
                    ]"
                  ></i
                ></span>
              </div>
              <el-checkbox-group v-model="commentStatusLabelList">
                <el-checkbox
                  v-for="(item, index) in commentStatusList"
                  :label="item.name"
                  :key="index"
                ></el-checkbox>
              </el-checkbox-group>
              <div class="popover-footer">
                <el-button
                  type="text"
                  size="small"
                  class="clear-bt"
                  @click="clearFilterLabel(4)"
                  >Clear All</el-button
                >
                <el-button
                  size="small"
                  class="apply-bt"
                  @click.stop="applyFilter(4)"
                  >Apply</el-button
                >
              </div>
            </el-popover>
            <el-popover
              placement="bottom-start"
              width="220"
              trigger="click"
              v-model="complainStatusPopoverShow"
              popper-class="mobile-filter-popover"
            >
              <div
                class="filter-btn-box"
                :class="{ 'select-filter': complainStatusLabelList.length > 0 }"
                slot="reference"
              >
                Complain Status<span class="arrow-box"
                  ><i
                    class="el-icon-arrow-down"
                    :class="[
                      { 'submenu-icon-arrow': complainStatusPopoverShow },
                    ]"
                  ></i
                ></span>
              </div>
              <el-checkbox-group v-model="complainStatusLabelList">
                <el-checkbox
                  v-for="(item, index) in complainStatusList"
                  :label="item.name"
                  :key="index"
                ></el-checkbox>
              </el-checkbox-group>
              <div class="popover-footer">
                <el-button
                  type="text"
                  size="small"
                  class="clear-bt"
                  @click="clearFilterLabel(5)"
                  >Clear All</el-button
                >
                <el-button
                  size="small"
                  class="apply-bt"
                  @click.stop="applyFilter(5)"
                  >Apply</el-button
                >
              </div>
            </el-popover>
          </div>
          <div class="search-box-reset-box">
            <el-button class="reset-bt" size="small" @click="resetFilter(2)"
              >Reset</el-button
            >
          </div>
        </div>

        <div class="search-box-li" v-if="showChildFilterLabels">
          <div
            class="filters-wrapper"
            v-for="(item, index) in childOrderStatuslabelList"
            :key="index"
          >
            {{ item }}
          </div>
          <div
            class="filters-wrapper"
            v-for="(item, index) in commentStatusLabelList"
            :key="'comment' + index"
          >
            {{ item }}
          </div>
          <div
            class="filters-wrapper"
            v-for="(item, index) in complainStatusLabelList"
            :key="'complain' + index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="order-course-list">
        <div
          class="list-content"
          v-for="(item, index) of childOrderList"
          :key="index"
        >
          <div>
            <div class="list-content_item_between">
              <div>
                Class ID {{ item.id }}
                <el-tooltip
                  v-if="
                    userInfo.id === item.applyId &&
                    item.changeapply === 1 &&
                    item.status === 1
                  "
                  effect="light"
                  content="Requesting for rescheduling"
                  placement="top"
                >
                  <i class="info-icon el-icon-warning"></i>
                </el-tooltip>
                <el-tooltip
                  v-if="item.changeapply === 2"
                  effect="light"
                  content="Rescheduled"
                  placement="top"
                >
                  <i class="info-icon el-icon-warning"></i>
                </el-tooltip>
                <el-tooltip
                  v-if="item.changeapply === 3"
                  effect="light"
                  content="Rescheduled failed"
                  placement="top"
                >
                  <i class="info-icon el-icon-warning"></i>
                </el-tooltip>
              </div>
              <span :style="{ color: childOrderStatusMap[item.status].color }">
                <i :class="childOrderStatusMap[item.status].icon"></i>
                <span>{{ childOrderStatusMap[item.status].name }}</span>
              </span>
            </div>
            <div class="list-content_item_between">
              {{ format(item.apdate, "ddd, MMM. Do") }}
              {{ item.starttime + "-" + item.endtime }}
            </div>
            <div class="list-content_item_between">
              <div class="class-site">
                site:
                <a v-if="item.roomsite" :href="item.roomsite" target="_blank"
                  >Go to the site</a
                >
              </div>
              <div>code: {{ item.roomcode }}</div>
            </div>

            <div
              class="time"
              v-if="
                item.complainstatus !== 0 && [1, 3, 4, 5].includes(item.status)
              "
            >
              {{ complainstatusMap[item.complainstatus] }}
            </div>

            <div :style="{ color: commentstatusMap[item.commentstatus].color }">
              <i :class="commentstatusMap[item.commentstatus].icon"></i>
              <span>{{ commentstatusMap[item.commentstatus].name }}</span>
            </div>

            <div class="list-content_item_op">
              <el-popover
                popper-class="mobile-op-popover"
                placement="top-end"
                width="150"
              >
                <div
                  class="more-op_item"
                  v-if="
                    item.complainstatus !== 0 &&
                    [1, 3, 4, 5].includes(item.status)
                  "
                  @click="viewappeal(item)"
                >
                  View appeal
                </div>
                <div
                  class="more-op_item"
                  v-if="item.status === 1"
                  @click="changeTime(item)"
                >
                  Rescheduling request
                </div>

                <el-popover
                  placement="right"
                  v-if="
                    userInfo.id !== item.applyId &&
                    item.changeapply === 1 &&
                    item.status === 1
                  "
                >
                  <div style="padding: 12px; font-size: 14px">
                    <div style="font-size: 20px; margin-bottom: 12px">
                      Check Reviews
                    </div>
                    <div>
                      <div>
                        Original time:
                        <span>{{
                          item.apdate +
                          " " +
                          item.starttime +
                          "-" +
                          item.endtime
                        }}</span>
                      </div>
                      <div style="margin-top: 12px">
                        Time submitted:
                        <span>{{ updateCourseTimeForm.targetTime }}</span>
                      </div>
                      <div style="margin-top: 12px">Your feedbacks:</div>
                      <el-radio
                        style="margin-top: 12px"
                        v-model="updateCourseTimeForm.changeapply"
                        :label="2"
                        >Yes</el-radio
                      >
                      <el-radio
                        v-model="updateCourseTimeForm.changeapply"
                        :label="3"
                        >No</el-radio
                      >
                      <div v-if="updateCourseTimeForm.changeapply === 3">
                        <div>Reason of rejection:</div>
                        <el-input
                          v-model="updateCourseTimeForm.reject_reason"
                        ></el-input>
                      </div>
                    </div>
                    <div style="margin-top: 20px; text-align: right">
                      <el-button
                        size="small"
                        style="background: #f48c06; color: #fff; border: none"
                        @click="handleConfirmUpdateTime"
                        >Sure</el-button
                      >
                    </div>
                  </div>
                  <div slot="reference" style="display: inline-block">
                    <el-badge is-dot>
                      <span class="op" @click="getUpdateCourseTime(item)"
                        >Rescheduling confirm</span
                      >
                    </el-badge>
                  </div>
                </el-popover>

                <el-badge
                  slot="reference"
                  :is-dot="
                    userInfo.id !== item.applyId &&
                    item.changeapply === 1 &&
                    item.status === 1
                  "
                >
                  <div class="watch-more">More</div>
                </el-badge>
              </el-popover>
              <div>
                <span
                  class="op"
                  v-if="[0, 1].includes(parseInt(item.status))"
                  @click="openCourseAddressDialog(item)"
                  >Address</span
                >
                <span
                  class="op"
                  v-if="item.status === 1"
                  @click="beginClass(item)"
                  >Begin</span
                >
                <span
                  class="op"
                  v-if="item.status === 3"
                  @click="finishClass(item)"
                  >Finish</span
                >
                <span
                  class="op"
                  v-if="item.status === 5 && item.commentstatus === 1"
                  @click="openReviewdialog(item)"
                  >Check</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <KtPag
      v-if="orderInformationVisible"
      style="text-align: right"
      :pageCount="childOrderForm.count"
      :currentPage="childOrderForm.page"
      :limit="childOrderForm.limit"
      @onChange="onChildOrderSizeChange"
    ></KtPag>

    <el-dialog
      v-if="commentInfo.covey_calendar"
      custom-class="reviews-dialog"
      :visible.sync="reviewDialog"
      append-to-body
      title="Course evaluation"
    >
      <div class="comment-card">
        <div class="comment-people">
          <div style="display: flex; align-items: center">
            <div class="circle">
              {{
                commentInfo.covey_calendar.covey_user.realname
                  ? commentInfo.covey_calendar.covey_user.realname[0]
                  : "-"
              }}
            </div>
            <span
              >{{
                commentInfo.covey_calendar.covey_user.realname || "-"
              }}
              (Student)</span
            >
          </div>
          <div class="main-title-right">
            <img src="@/assets/icon/star.png" />
            <span>{{ commentInfo.rate }}</span>
          </div>
        </div>
        <div class="comment-content">{{ commentInfo.content }}</div>
        <div class="comment-time">{{ format(commentInfo.comment_time) }}</div>
      </div>

      <div class="reply-card" v-if="commentInfo.is_reply === 1">
        <div class="reply-content">
          <div>
            See the response {{ userInfo.realname }}(Me) :
            {{ commentInfo.replied_content }}
          </div>
          <div class="comment-time">{{ format(commentInfo.comment_time) }}</div>
        </div>
      </div>

      <div v-if="commentInfo.is_reply !== 1">
        <el-input
          type="textarea"
          style="margin-top: 32px"
          v-model="replied_content"
          :rows="4"
          placeholder="Give him a reply right now!"
        ></el-input>
        <div class="box-foot">
          <div class="my-button cancel" @click="reviewDialog = false">
            CANCEL
          </div>
          <div class="my-button" @click="handleReply">SURE</div>
        </div>
      </div>
      <div v-if="commentInfo.is_reply === 1" class="box-foot">
        <div class="my-button cancel" @click="reviewDialog = false">CANCEL</div>
        <div class="my-button" @click="reviewDialog = false">SURE</div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="changeTimeDialog"
      title="Select the time to modify."
      width="80%"
    >
      <ScheduleTable
        v-if="changeTimeDialog"
        @TempSchedule="onTempScheduleChange"
        :highlightTable="[myClassTable]"
        :classSlot="myClassTable.slot"
        :multiple="false"
      >
      </ScheduleTable>
      <div class="box-foot">
        <div class="my-button cancel" @click="changeTimeDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="handleChangeTime">SURE</div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="courseAddressDialog" title="Course address">
      <div class="form-item">
        <div class="form-title">Copy course link:</div>
        <div class="form-content">
          <el-input
            v-model="courseAddressForm.roomsite"
            class="input-link"
            placeholder="Copy course link"
          ></el-input>
        </div>
      </div>
      <div class="form-item">
        <div class="form-title">Course code:</div>
        <div class="form-content">
          <el-input
            style="width: 40%"
            v-model="courseAddressForm.roomcode"
            placeholder="Course code"
          ></el-input>
        </div>
      </div>

      <div class="box-foot">
        <div class="my-button cancel" @click="courseAddressDialog = false">
          CANCEL
        </div>
        <div
          class="my-button"
          @click="handleUpdateRoom"
          v-loading="updateRoomLoading"
        >
          SURE
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="appealResDialog"
      title="Support case result"
      width="80%"
    >
      <el-form :model="appealRes">
        <el-form-item label="Order number:">
          <div>{{ appealRes.calendarId }}</div>
        </el-form-item>

        <el-form-item label="Description of issue:">
          <el-input
            type="textarea"
            v-model="appealRes.reason"
            :rows="5"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="Supporting materials:">
          <div
            style="
              display: inline-block;
              margin-right: 12px;
              margin-bottom: 12px;
            "
            v-for="(item, index) in appealRes.proofImg"
            :key="index"
          >
            <img style="width: 180px; height: auto" :src="item" />
          </div>
        </el-form-item>

        <el-form-item label="Tutor penalty amount:">
          <div>C$ {{ appealRes.tutorpunishment | formatMoneyNumber }}</div>
        </el-form-item>

        <el-form-item label="Send students coupons:">
          <div>C$ {{ appealRes.sturefund | formatMoneyNumber }}</div>
        </el-form-item>

        <el-form-item label="Status of case:">
          <div>{{ appealStatus[appealRes.status] }}</div>
        </el-form-item>
      </el-form>
      <div class="box-foot">
        <div class="my-button cancel" @click="appealResDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="appealResDialog = false">SURE</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ScheduleTable from "@/views/Mobile/Component/ScheduleTable";
import { format } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
import KtPag from "@/views/Comm/KtPag";
export default {
  filters: {
    formatMoneyNumber(value) {
      if (typeof value === "number" && !isNaN(value)) {
        //必要
        return (Number(value) / 100).toFixed(2);
      } else {
        return "-";
      }
    },
  },
  components: {
    ScheduleTable,
    KtPag,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
      xToken: (state) => state.app.token,
    }),
    showFilterLabels() {
      return (
        this.orderStatusLabelList.length > 0 ||
        this.refundStatusLabelList.length > 0
      );
    },
    showChildFilterLabels() {
      return (
        this.childOrderStatuslabelList.length > 0 ||
        this.commentStatusLabelList.length > 0 ||
        this.complainStatusLabelList.length > 0
      );
    },
  },
  data() {
    return {
      activeName: 1,
      orderlist: [],
      orderlistForm: {
        page: 1,
        limit: 10,
        count: 0,
      },
      format: format,
      orderInformationVisible: false,
      reviewDialog: false,
      isReplied: false,

      refund_status: {
        //退款状态
        0: { name: "Not applied", icon: "", color: "" },
        1: {
          name: "Refund in progress",
          icon: "el-icon-info",
          color: "#f48c06",
        },
        2: {
          name: "Refund:Tutor agreed",
          icon: "el-icon-success",
          color: "#3BB20A",
        },
        3: {
          name: "Refund:Tutor rejected",
          icon: "el-icon-error",
          color: "#f56c6c",
        },
      },
      orderStatusMap: {
        //父订单
        1: { name: "To be paid", icon: "el-icon-remove", color: "#7E8088" },
        2: { name: "Paid", icon: "el-icon-success", color: "#3BB20A" },
        3: { name: "Canceled", icon: "el-icon-error", color: "#f56c6c" },
        4: { name: "Ongoing", icon: "el-icon-circle-check", color: "#f48c06" },
        5: { name: "Completed", icon: "el-icon-success", color: "#3BB20A" },
      },
      childOrderStatusMap: {
        //子订单
        "-1": { name: "Invalid", icon: "el-icon-remove", color: "#7E8088" },
        0: { name: "No appointment", icon: "el-icon-remove", color: "#f48c06" },
        1: { name: "Booked", icon: "el-icon-success", color: "#3BB20A" },
        2: { name: "Canceled", icon: "el-icon-error", color: "#f56c6c" },
        3: { name: "In class", icon: "el-icon-collection", color: "#f48c06" },
        4: { name: "To be confirmed", icon: "el-icon-error", color: "#f48c06" },
        5: { name: "Completed", icon: "el-icon-success", color: "#3BB20A" },
      },
      complainstatusMap: {
        0: "No supporting case filed.",
        1: "Supporting case in progress.",
        2: "Supporting case solved.",
        3: "Case failed.",
      },
      commentstatusMap: {
        //子订单的评论状态
        0: { name: "Not evaluated", icon: "el-icon-remove", color: "" },
        1: { name: "Evaluated", icon: "el-icon-success", color: "#3BB20A" },
        2: { name: "Auto", icon: "el-icon-success", color: "#3BB20A" },
      },
      appealStatus: {
        1: "In progress",
        2: "Warning tutor",
        3: "Penalty tutor",
        4: "Refund",
      },

      orderDetail: {},
      childOrderList: [], //子订单列表
      commentInfo: {}, //学生评价
      replied_content: "", //回复评价的内容
      myClassTable: [], //点击change time 时修改的课程
      changeTimeDialog: false,
      updateCourseTimeForm: {
        //
        targetTime: "", //申请的时间
        new_calendar_id: "",
        id: "",
        changeapply: 2, //2表示同意 3表示拒绝
        reject_reason: "", //拒绝时要填写原因
      },

      confirmWithdrawForm: {
        id: "",
        refund_status: 2, //2同意 3拒绝
      },
      childOrderForm: {
        page: 1,
        limit: 10,
        count: 0,
      },

      courseAddressDialog: false, //课程详情中的课程地址
      courseAddressForm: {
        //上课地址
        roomsite: "",
        roomcode: "",
        id: "",
      },
      updateRoomLoading: false,

      //申述
      appealResDialog: false,
      appealRes: {},
      withdrawPopoverVisible: false,
      orderStatusList: [
        { name: "To be paid", status: 1 },
        { name: "Paid", status: 2 },
        { name: "Canceled", status: 3 },
        { name: "In progress", status: 4 },
        { name: "Completed", status: 5 },
      ],
      orderStatusLabelList: [],
      orderPopoverShow: false,
      refundStatusList: [
        //退款状态
        { name: "Not applied", status: 0 },
        {
          name: "In progress",
          status: 1,
        },
        {
          name: "Tutor agreed",
          status: 2,
        },
        {
          name: "Tutor rejected",
          status: 3,
        },
      ],
      refundStatusLabelList: [],
      refundPopoverShow: false,
      childOrderStatusList: [
        //子订单
        {
          name: "No appointment",
          status: 0,
        },
        { name: "Booked", status: 1 },
        { name: "Canceled", status: 2 },
        { name: "In class", status: 3 },
        { name: "To be confirmed", status: 4 },
        { name: "Completed", status: 5 },
      ],
      childOrderStatuslabelList: [],
      childOrderPopoverShow: false,
      commentStatusList: [
        //子订单的评论状态
        { name: "Not evaluated", status: 0 },
        { name: "Evaluated", status: 1 },
        { name: "Auto", status: 2 },
      ],
      commentStatusLabelList: [],
      commentStatusPopoverShow: false,
      complainStatusList: [
        //投诉状态
        { name: "No supporting case filed", status: 0 },
        { name: "Supporting case in progress", status: 1 },
        { name: "Supporting case solved", status: 2 },
        { name: "Case failed", status: 3 },
      ],
      complainStatusLabelList: [],
      complainStatusPopoverShow: false,
    };
  },

  watch: {
    "$route.query": function (newVal, oldVal) {
      this.initPage();
    },
  },
  created() {
    this.initPage();
  },
  methods: {
    orderProgressFomat(p, item) {
      return (
        "Total:" +
        item.amounts +
        " Used:" +
        item.used_amounts +
        " Canceled:" +
        item.cancel_amounts
      );
    },
    initPage() {
      if (this.$route.query && this.$route.query.orderId) {
        if (!this.orderDetail.covey_course) {
          this.$router.push({
            path: "/teach/sold",
          });
          return;
        }
        this.orderInformationVisible = true;
        this.getChildOrderList(1);
      } else if (this.$route.query && this.$route.query.Id) {
        //如果有id进来 则加参数
        this.orderInformationVisible = false;
        this.orderlistForm.id = this.$route.query.Id;
        this.getOrderList(1);
      } else {
        this.orderInformationVisible = false;
        delete this.orderlistForm.id; //清除Id的参数
        this.getOrderList(1);
      }
    },
    onOrderPageChange({ page, limit }) {
      this.orderlistForm.page = page;
      this.orderlistForm.limit = limit;
      this.getOrderList(2);
    },
    getOrderList(type) {
      if (type === 1) {
        this.orderlistForm.page = 1;
      }
      let params = { ...this.orderlistForm };
      if (this.orderStatusLabelList.length > 0) {
        params["order_status"] = this.orderStatusList
          .map((item) => {
            for (let label of this.orderStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.refundStatusLabelList.length > 0) {
        params["refund_status"] = this.refundStatusList
          .map((item) => {
            for (let label of this.refundStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      delete params.count;
      this.$api.courseApi.getTeachOrders(params).then((res) => {
        if (res.status === "0") {
          this.orderlist = res.data.rows;
          res.data.rows.forEach((item) => {
            item.covey_course.courseImg = JSON.parse(
              item.covey_course.courseImg
            );
          });
          this.orderlistForm.count = res.data.count;
        }
      });
    },
    onChildOrderSizeChange({ page, limit }) {
      this.childOrderForm.page = page;
      this.childOrderForm.limit = limit;
      this.getChildOrderList(2);
    },
    //课程订单详情页面下的子订单列表
    getChildOrderList(type) {
      if (type === 1) {
        this.childOrderForm.page = 1;
      }
      let params = { ...this.childOrderForm };
      params["orderId"] = this.$route.query.orderId;
      params["type"] = "2";
      if (this.childOrderStatuslabelList.length > 0) {
        params["status"] = this.childOrderStatusList
          .map((item) => {
            for (let label of this.childOrderStatuslabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.commentStatusLabelList.length > 0) {
        params["commentstatus"] = this.commentStatusList
          .map((item) => {
            for (let label of this.commentStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.complainStatusLabelList.length > 0) {
        params["complainstatus"] = this.complainStatusList
          .map((item) => {
            for (let label of this.complainStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      delete params.count;
      this.childOrderList = [];
      this.$api.courseApi.getOrderLessons(params).then((res) => {
        if (res.status === "0") {
          this.childOrderList = res.data.rows;
          this.childOrderForm.count = res.data.count;
        }
      });
    },
    //回复学生评价
    // todo
    openReviewdialog(item) {
      if (item.covey_comment && item.covey_comment.comment_id) {
        this.getComment(item.covey_comment.comment_id);
        this.reviewDialog = true;
      }
    },
    getComment(comment_id) {
      this.$api.orderApi
        .getCommentById({ comment_id: comment_id })
        .then((res) => {
          this.commentInfo = res.data;
        });
    },
    // 回复评价
    handleReply() {
      if (!this.replied_content) {
        return;
      }
      let params = {
        comment_id: this.commentInfo.comment_id,
        replied_content: this.replied_content,
      };
      this.$api.courseApi.replyComment(params).then((res) => {
        if (res.status === "0") {
          this.getComment(params.comment_id);
          this.$message.success("Success!");
        } else {
          this.$message.error("Error:" + res.message);
        }
      });
    },
    //查看订单
    checkOrder(item) {
      this.orderDetail = item;
      this.$router.push({
        path: this.$route.path,
        query: {
          orderId: item.id,
        },
      });
    },

    //处理退款
    confirmWithdraw(item) {
      this.confirmWithdrawForm.id = item.id;
      this.withdrawPopoverVisible = !this.withdrawPopoverVisible;
    },
    handleConfirmWithdraw() {
      this.$confirm("Submit a refund request?", "", {
        type: "warning",
      })
        .then(() => {
          let params = { ...this.confirmWithdrawForm };
          this.$api.orderApi.confirmwithdraw(params).then((res) => {
            if (res.status === "0") {
              this.$message.success(res.message);
              this.getOrderList(1);
            } else {
              this.$message.error("Error!" + res.message);
            }
          });
        })
        .catch((err) => {});
    },

    //子订单 ，更改时间
    changeTime(item) {
      this.myClassTable = item;
      this.changeTimeDialog = true;
    },
    onTempScheduleChange(data) {
      this.scheduleData = data;
    },

    //开始课程
    beginClass(item) {
      this.$confirm("Are you sure you want to start the course?", "", {
        type: "warning",
      })
        .then(() => {
          this.$api.courseApi.beginLession({ id: item.id }).then((res) => {
            if (res.status === "0") {
              this.$message.success(res.message);
              this.getChildOrderList(1);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch((err) => {});
    },
    //结束课程
    finishClass(item) {
      this.$confirm("End session?", "", {
        type: "warning",
      })
        .then(() => {
          this.$api.courseApi.finishLession({ id: item.id }).then((res) => {
            if (res.status === "0") {
              this.$message.success(res.message);
              this.getChildOrderList(1);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch((err) => {});
    },
    //修改课程时间 提交数据
    handleChangeTime() {
      if (this.scheduleData && this.scheduleData.length > 0) {
        let params = { ...this.scheduleData[0] };
        params.id = this.myClassTable.id;
        this.$api.courseApi.updateCourseTime(params).then((res) => {
          if (res.status === "0") {
            this.$message.success(res.message);
            this.changeTimeDialog = false;
            this.getChildOrderList(1);
          } else {
            this.$message.error("Error!" + res.message);
          }
        });
      }
    },
    //调课申请
    getUpdateCourseTime(item) {
      this.updateCourseTimeForm.id = item.id;
      this.updateCourseTimeForm.new_calendar_id = item.new_calendar_id;
      this.$api.courseApi
        .getUpdateCourseTime({ new_calendar_id: item.new_calendar_id })
        .then((res) => {
          if (res.status === "0") {
            this.updateCourseTimeForm.targetTime =
              res.data.apdate +
              " " +
              res.data.starttime +
              "-" +
              res.data.endtime;
          } else {
            this.$message.error("Error!" + res.message);
          }
        });
    },
    //调课申请 点击sure
    handleConfirmUpdateTime() {
      let params = { ...this.updateCourseTimeForm };
      delete params.targetTime;

      this.$api.courseApi.confirmUpdateCourseTime(params).then((res) => {
        if (res.status === "0") {
          this.$message.success(res.message);
          this.getChildOrderList(1);
        } else if (res.status === "500") {
          this.$message.error("Rejected automatically due to time conflict.");
          this.getChildOrderList(1);
        } else {
          this.$message.error("Error!" + res.message);
        }
      });
    },

    //打开地址
    openCourseAddressDialog(item) {
      this.courseAddressForm.roomcode = item.roomcode || "";
      this.courseAddressForm.roomsite = item.roomsite || "";
      this.courseAddressForm.id = item.id;
      this.courseAddressDialog = true;
    },

    //更新上课url
    handleUpdateRoom() {
      let params = { ...this.courseAddressForm };
      if (!(params.roomsite || params.roomcode)) {
        return;
      }

      this.updateRoomLoading = true;
      this.$api.courseApi.updateCourseCalendar(params).then((res) => {
        if (res.status === "0") {
          this.getChildOrderList(1);
          this.courseAddressDialog = false;
          this.$message.success("Success!");
        } else {
          this.$message.error("Error! Reason:" + res.message);
        }
        this.updateRoomLoading = false;
      });
    },

    //查看申述结果
    viewappeal(item) {
      this.appealResDialog = true;
      this.getAppealResult(item.id);
    },
    // 获取申述内容
    getAppealResult(id) {
      this.$api.orderApi.getappeal({ calendarId: id }).then((res) => {
        res.data.proofImg = JSON.parse(res.data.proofImg);

        this.appealRes = res.data;
      });
    },
    contactPeople(id) {
      if (!this.xToken) {
        this.$router.push({
          path: "/login",
          query: {
            returnto: this.$route.fullPath,
          },
        });
        return;
      }
      if (id === this.userInfo.id) {
        this.$message.error("Can't talk to yourself!");
        return;
      }
      //   let routeData = this.$router.resolve({
      //     path: "/chat?contactId=" + id,
      //   });
      //   window.open(routeData.href, "_blank");
      this.$router.push("/chatmain?contactId=" + id);
    },
    clearFilterLabel(type) {
      if (type === 1) {
        this.orderStatusLabelList = [];
      } else if (type === 2) {
        this.refundStatusLabelList = [];
      } else if (type === 3) {
        this.childOrderStatuslabelList = [];
      } else if (type === 4) {
        this.commentStatusLabelList = [];
      } else if (type === 5) {
        this.complainStatusLabelList = [];
      }
    },
    applyFilter(type) {
      if (type === 1) {
        this.getOrderList(1);
        this.orderPopoverShow = false;
      } else if (type === 2) {
        this.getOrderList(1);
        this.refundPopoverShow = false;
      } else if (type === 3) {
        this.getChildOrderList(1);
        this.childOrderPopoverShow = false;
      } else if (type === 4) {
        this.getChildOrderList(1);
        this.commentStatusPopoverShow = false;
      } else if (type === 5) {
        this.getChildOrderList(1);
        this.complainStatusPopoverShow = false;
      }
    },
    resetFilter(type) {
      if (type === 1) {
        this.orderStatusLabelList = [];
        this.refundStatusLabelList = [];
        this.getOrderList(1);
      } else if (type === 2) {
        this.childOrderStatuslabelList = [];
        this.commentStatusLabelList = [];
        this.complainStatusLabelList = [];
        this.getChildOrderList(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.HasBeenSold-box {
  height: 100%;
  box-sizing: border-box;
  .search-box {
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    padding: 12px;
    margin: 12px 0;
    box-sizing: border-box;
    .search-box-fliter-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .search-box-fliter {
        display: flex;
        flex-wrap: wrap;
      }
    }
    .select-filter {
      color: #f48c06 !important;
      border-color: #f8d19e !important;
      background-color: #ffffff !important;
    }
    .filter-btn-box {
      font-weight: 600;
      font-size: 12px;
      color: #7e8088;
      min-width: 50px;
      padding: 6px;
      border-radius: 4px;
      border: 1px solid #dadbdd;
      margin: 0 10px 10px 0;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
      .arrow-box {
        margin-left: 6px;
        i {
          transition: all 500ms;
          font-size: 12px;
          &:hover {
            color: #f48c06;
            border-color: #f8d19e;
            background-color: #ffffff;
          }
        }
      }
      .submenu-icon-arrow {
        transform: rotate(180deg);
      }
    }
    .reset-bt {
      font-size: 12px;
      color: #7e8088;
      font-weight: 600;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
    }
  }
  .search-box-li {
    // height: 35px;
    // padding: 6px 0;
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    .filters-wrapper {
      color: #7e8088;
      font-size: 12px;
      // line-height: 22px;
      font-weight: 600;
      background-color: #efeff0;
      margin: 0 10px 10px 0;
      padding: 3px 12px;
      // border: none;
      border-radius: 50px;
      box-sizing: border-box;
    }
  }
  .goback {
    color: #f48c06;
  }
  .operation_events {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    color: #f48c06;
    height: 100%;
  }
  .class-site {
    a {
      color: #f48c06;
      text-decoration: none;
      text-decoration: underline;
    }
  }
  //限制长度
  .limit-length {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .chat-icon {
    font-size: 18px;
    cursor: pointer;
    color: #f48c06;
  }
  .list-content:nth-child(n + 2) {
    border-top: 1px solid #dbd9d6;
  }
  .list-content {
    line-height: 24px;
    padding: 12px 0;
    box-sizing: border-box;
  }
  .info-img {
    width: 100px;
    height: 80px;
    border-radius: 2px;
  }
  .list-content_item_status {
    font-size: 14px;
  }
  .list-content_item_title {
    font-size: 18px;
    width: 100%;
    text-transform: capitalize;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    .title_main {
      width: 70%;
    }
  }
  .list-content_item_container {
    display: flex;
    width: 100%;
    .list-content_item_right {
      padding-left: 12px;
      width: calc(100% - 100px);
    }
  }
  .margin-top_8 {
    margin-top: 8px;
  }
  .list-content_item_between {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  .info-icon {
    font-size: 14px;
    color: #f48c06;
  }
  .myinfo-com-has-content {
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    padding: 0 12px;
    .list-content {
      font-size: 16px;
    }
  }
  .time {
    font-size: 14px;
    color: #999;
    span {
      width: 80px;
    }
  }

  .order-information {
    line-height: 24px;
    .order-information_top {
      margin-bottom: 12px;
    }
    .flex-box {
      display: flex;
    }
    .top-box {
      background: #fff;
      padding: 12px;
      border-radius: 4px;
    }
    .top-box_right {
      padding-left: 12px;
      width: calc(100% - 112px);
      .info-title {
        font-size: 18px;
      }
      .info-detail {
      }
      .price {
        color: #999;
        font-size: 14px;
      }
    }
    .order-fee {
      height: 24px;
      font-size: 24px;
      font-weight: 600;
      color: #f48c06;
      line-height: 24px;
    }
    .item-title {
      height: 30px;
      font-size: 24px;
      font-weight: 600;
      color: #201002;
      line-height: 30px;
      margin-top: 16px;
      display: flex;
      justify-content: space-between;
    }

    .order-course-list {
      padding: 0 12px;
      margin-top: 8px;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      background: #ffffff;
    }
  }

  .list-content_item_op {
    font-size: 14px;
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    color: #999;
    .op {
      color: #f48c06;
      display: inline;
      margin-left: 8px;
      background: #fae4c7;
      padding: 2px;
      border-radius: 4px;
    }
  }
  .watch-more {
    line-height: 14px;
  }

  /deep/.el-dialog__body {
    padding: 16px;
  }
  .form-item {
    margin-bottom: 20px;
    .form-title {
      margin-bottom: 12px;
    }
  }
  .refund {
    margin-top: 8px;
    font-size: 14px;
    color: #f48c06;
  }
}

.reviews-dialog {
  border-radius: 8px;
  .el-dialog__header {
    padding: 32px 0;
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #201002;
    .el-dialog__title {
      font-size: 24px;
    }
  }
  .el-dialog__body {
    padding: 0 56px 46px;
    box-sizing: border-box;

    .comment-card {
      margin-top: 16px;
      padding: 16px;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;

      .comment-people {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .circle {
          width: 32px;
          height: 32px;
          background: #fecb3e;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          line-height: 32px;
          border-radius: 50%;
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .comment-content {
        height: auto;
        font-size: 14px;
        font-weight: 600;
        color: #201002;
        line-height: 30px;
        margin-top: 16px;
      }
      .main-title-right {
        padding: 6px 16px;
        border-radius: 24px;
        background: rgba(252, 233, 209, 0.54);
        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }

    .comment-time {
      text-align: right;
      height: auto;
      font-size: 14px;
      font-weight: 600;
      color: #b7b2ae;
      line-height: 30px;
      margin-top: 16px;
    }

    .reply-card {
      width: 100%;
      margin-top: 16px;
      display: flex;
      justify-content: flex-end;
      .reply-content {
        width: 65%;
        background: #e4e4e4;
        padding: 16px;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        line-height: 30px;
        color: #201002;
        font-weight: 600;
      }
    }

    .el-textarea__inner {
      font-family: "PingFangSC-Semibold", "PingFang SC";
      border-radius: 8px;
    }
  }
}

.box-foot {
  margin-top: 56px;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.my-button {
  cursor: pointer;
  width: 120px;
  height: 48px;
  background: #f48c06;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  span {
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
  }
}
.cancel {
  margin-right: 24px;
  background: #f2f2f2;
  color: #201002;
}
</style>
